import Permission from '@common/components/permission';
import { EPermissions } from '@common/definitions';
import React, { useState } from 'react';
import UploadForm from '@modules/schedules/forms/upload';
import { Trans } from 'react-i18next';
import { useAppSelector } from '@common/hooks';
import * as networkSelector from '../../../network/selectors/network';
import * as userSelector from '../../../core/selectors/logged-user';
import * as schedulesSelector from '@modules/schedules/selectors/schedules';
import * as R from 'ramda';
import Icon from '@common/components/icon';
import { Moment } from 'moment';
import { useDispatch } from 'react-redux';
import { initialize } from 'redux-form';
import { TableDropdown } from '@common/components/table';

const UploadSchedule = ({ currentWeek, refetchSchedules }: { currentWeek: Moment, refetchSchedules: () => void }) => {
  const [isUploadModalVisible, setIsUploadModalVisible] =
    useState<boolean>(false);
  const network = useAppSelector((state) => networkSelector.selected(state));
  const functions = useAppSelector((state) => userSelector.functions(state, EPermissions.NETWORK_SCHEDULES_VIEW_ALL)
  );
  const schedules = useAppSelector((state) => schedulesSelector.schedulesByWeek(state)
  );
  const form = useAppSelector((state) => state.form['upload-schedule']);

  const dispatch = useDispatch();
  const handleAddSchedule = (schedule: { date: string; value: string }) => {
    dispatch(
      initialize('upload-schedule', {
        week: schedule.date,
        function_id: schedule.value || 'network',
        schedule: null,
      })
    );
    setIsUploadModalVisible(true);
  };
  return (
    <>
      <Permission
        name={[
          EPermissions.NETWORK_FUNCTION_MEMBERSHIPS_SCHEDULES_CREATE,
          EPermissions.NETWORK_SCHEDULES_CREATE,
        ]}
      >
        <TableDropdown.Item
          onClick={() => handleAddSchedule({
              date: currentWeek.format('YYYY-MM-DD'),
              value: 'network',
            })}
        >
          <div role="button" className="flex items-center space-x-2">
            <Icon type="calendar_today" />
            <Trans i18nKey="schedules:container_upload_button" />
          </div>
        </TableDropdown.Item>
      </Permission>
      <Permission
        name={[
          EPermissions.NETWORK_FUNCTION_MEMBERSHIPS_SCHEDULES_CREATE,
          EPermissions.NETWORK_SCHEDULES_CREATE,
        ]}
      >
        {isUploadModalVisible && (
          <UploadForm
            key="form"
            {...({ onClose: () => setIsUploadModalVisible(false) } as any)}
            network={network}
            functions={functions}
            schedules={R.filter(
              R.has('id'),
              R.flatten(R.pluck('data', schedules as any[]))
            )}
            formValues={form?.values}
            refetchSchedules={refetchSchedules}
          />
        )}
      </Permission>
    </>
  );
};

export default UploadSchedule;
